




import { Prop, Component, Vue } from "vue-property-decorator";

@Component({})
export default class IconLogo extends Vue {
  @Prop({ default: 18 }) private radius!: number;
  @Prop({ default: "" }) alt!: string;

  private get width(): string {
    return `${this.radius * 2}px`;
  }

  private get height(): string {
    return `${this.radius * 1.5}px`;
  }
}
